import { Typography } from "@mui/material";

export default function BaseTypography({ type = 'content', className, children, sx, ...props }) {
  return (
    <Typography
      className={className}
      variant={props.variant || 'h2'}
      sx={{
        fontFamily: 'Lato, sans-serif',
        textAlign: 'left',
        fontSize: type === 'heading' ? '22px' : type === 'label' ? '18px' : '20px',
        fontWeight: type === 'heading' ? 900 : type === 'label' ? 700 : 400,
        color: type === 'heading' ? '#000000' : type === 'label' ? '#1D2A83' : '#545454',
        fontStyle: type === 'label' ? 'italic' : 'normal',
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
};